import DesktopPopularSearchPanel from "./desktop-popular-search-panel";
import DesktopSearchNearbyCard from "./desktop-search-nearby-card";
import DesktopSearchResults from "./desktop-search-results";
import { normalizeTerm } from "./search-utils";

const DesktopSearchPopover = ({
  id,
  searchState,
  suggestionState,
  searchActions,
  desktopNavigationState,
}) => {
  const { search } = searchState;
  const { routeToSearch, routeToBestSearchTarget, routeToPlace } = searchActions;
  const {
    nearbyOnly,
    setNearbyOnly,
    popularItems,
    popularUpdatedAt,
    topPlace,
    matchedRecentTerms,
    suggestionTerms,
    userLocation,
    isSuggestionLoading,
    placeSuggestions,
  } = suggestionState;
  const trimmedSearch = normalizeTerm(search);
  const hasTypedSearch = trimmedSearch.length > 0;
  const visiblePlaceSuggestions =
    Array.isArray(placeSuggestions) && placeSuggestions.length > 0
      ? placeSuggestions
      : topPlace
        ? [topPlace]
        : [];

  return (
    // ⚠️ 예전에는 `left-1/2 -translate-x-1/2` 로 검색창 «가운데»에 맞췄다.
    //    패널(640px)이 검색창(500px)보다 넓어서 왼쪽 43px 이 데스크톱 사이드바
    //    밑으로 들어갔고, 「주변만 보기」가 「변만 보기」로 잘려 보였다(2026-08-16).
    //    검색창 왼쪽 끝에 맞추면 오른쪽으로만 자라서 가려지지 않는다.
    <div
      id={id}
      className="absolute left-0 top-[calc(100%+12px)] z-[120] hidden overflow-y-auto rounded-[22px] border border-black/5 bg-white px-6 py-5 text-black shadow-[0_22px_60px_rgba(15,23,42,0.16)] md:block dark:border-white/10 dark:bg-custom_black dark:text-white"
      style={{
        width: "min(calc(100vw - 2rem), 640px)",
        maxHeight: "min(calc(100vh - 104px), 720px)",
      }}
    >
      <DesktopSearchNearbyCard
        nearbyOnly={nearbyOnly}
        setNearbyOnly={setNearbyOnly}
      />

      {hasTypedSearch ? (
        <DesktopSearchResults
          trimmedSearch={trimmedSearch}
          visiblePlaceSuggestions={visiblePlaceSuggestions}
          topPlace={topPlace}
          matchedRecentTerms={matchedRecentTerms}
          suggestionTerms={suggestionTerms}
          userLocation={userLocation}
          isSuggestionLoading={isSuggestionLoading}
          onSubmit={routeToBestSearchTarget}
          onPlaceClick={routeToPlace}
          desktopNavigationState={desktopNavigationState}
        />
      ) : (
        <DesktopPopularSearchPanel
          popularItems={popularItems}
          updatedAt={popularUpdatedAt}
          onSubmit={routeToSearch}
          desktopNavigationState={desktopNavigationState}
        />
      )}
    </div>
  );
};

export default DesktopSearchPopover;
